var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/linagora.esn.calendar/app/components/show-main-sidebar-button/show-main-sidebar-button.pug");
module.exports = (req['default'] || req).apply(req, [])